import script from "./Signup.vue?vue&type=script&setup=true&lang=js"
export * from "./Signup.vue?vue&type=script&setup=true&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=5b165849&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b165849"]])

export default __exports__